<template>
  <div class="custom-login-view">
    <h2>Debug Login</h2>
    <form @submit.prevent="handleDebugLogin">
      <div class="form-group">
        <label for="thridPartyLoginId">Third Party Login ID:</label>
        <input type="text" id="thridPartyLoginId" v-model="thridPartyLoginId" required />
      </div>
      <button type="submit" :disabled="isLoadingDebugLogin">
        {{ isLoadingDebugLogin ? 'Logging in...' : 'Debug Login' }}
      </button>
    </form>
    <p v-if="debugLoginError" class="error-message">{{ debugLoginError }}</p>
  </div>
</template>

<script>
import { defineComponent, ref } from 'vue';
import { useRouter } from 'vue-router';

export default defineComponent({
  name: 'CustomLoginView',
  setup() {
    const router = useRouter();

    const thridPartyLoginId = ref('');
    const debugLoginError = ref('');
    const isLoadingDebugLogin = ref(false);


    const handleDebugLogin = async () => {
      if (!thridPartyLoginId.value) {
        debugLoginError.value = 'Third Party Login ID is required.';
        return;
      }
      isLoadingDebugLogin.value = true;
      debugLoginError.value = '';

      try {
        const response = await fetch('https://train.dudustudio.monster/api/Account/DebugLogin', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({ ThridPartyLoginId: thridPartyLoginId.value }),
        });

        if (response.ok) {
          const data = await response.json();
          if (data.Success && data.Token) {
            localStorage.setItem('apiToken', data.Token);
            localStorage.setItem('customUserLoggedIn', 'true');
            alert('Debug Login Successful! Redirecting...');
            setTimeout(() => {
              router.push({ name: 'WelcomePage' });
            }, 0);
          } else {
            debugLoginError.value = data.Message || 'Debug login failed. Please check the ID.';
          }
        } else {
          let errorData;
          try {
            errorData = await response.json();
          } catch (e) {
            errorData = { Message: `HTTP error ${response.status}` };
          }
          debugLoginError.value = errorData.Message || `An error occurred: ${response.statusText}`;
        }
      } catch (error) {
        console.error('Debug Login API call failed:', error);
        debugLoginError.value = 'Network error or API is unreachable. Please try again.';
      } finally {
        isLoadingDebugLogin.value = false;
      }
    };

    return {
      thridPartyLoginId,
      handleDebugLogin,
      debugLoginError,
      isLoadingDebugLogin,
    };
  },
});
</script>

<style scoped>
.custom-login-view {
  max-width: 400px;
  margin: 50px auto;
  padding: 20px;
  border: 1px solid #ccc;
  border-radius: 8px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.form-group {
  margin-bottom: 15px;
}

label {
  display: block;
  margin-bottom: 5px;
}

input[type="password"],
input[type="text"] {
  width: 100%;
  padding: 8px;
  box-sizing: border-box;
  border: 1px solid #ddd;
  border-radius: 4px;
}

button {
  padding: 10px 15px;
  background-color: #007bff;
  color: white;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  min-width: 100px;
}

button:hover {
  background-color: #0056b3;
}

button:disabled {
  background-color: #cccccc;
  cursor: not-allowed;
}

.error-message {
  color: red;
  margin-top: 10px;
}

.divider {
  margin-top: 30px;
  margin-bottom: 30px;
  border: 0;
  border-top: 1px solid #eee;
}
</style> 